<template>
  <main class="main login-page">
    <div class="main-wrapper">
      <div class="container">
        <div class="left">
          <div class="left-up">
            <div @click="$parent.closeSignInModal" class="desc back">
              {{$t('Back to mainpage')}}
            </div>
            <div class="form">
              <div class="form-wrapper">
                <div class='form-fields register-content'>
                  <div class="form-fields-wrapper">
                    <div class="title medium">{{$t('Sign Up')}}</div>
                    <label>
                      <div class="desc">*{{$t('Name')}}</div>
                      <input type="text" :placeholder="$t('Name')" v-model="name"/>
                    </label>
                    <label>
                      <div class="desc">*{{$t('Surname')}}</div>
                      <input type="text" :placeholder="$t('Surname')" v-model="surname"/>
                    </label>
                    <label>
                      <div class="desc">*{{$t('Phone')}}</div>
                      <input type="number" :placeholder="$t('Phone')" v-model="phone"/>
                    </label>
                    <label>
                      <div class="desc">*{{$t('Email')}}</div>
                      <input type="email" :placeholder="$t('Email')" v-model="email"/>
                    </label>
                    <label>
                      <div class="desc">*{{$t('Password')}}</div>
                      <input type="password" :placeholder="$t('Password')" v-model="pass"/>
                    </label>
                    <label>
                      <div class="desc">*{{$t('Confirm password')}}</div>
                      <input type="password" :placeholder="$t('Confirm password')" v-model="passConfirm"/>
                    </label>
                    <div class="chekbox-container">
                      <label class="chekbox-label">
                        <div class="chekbox-label-wrapper">
                          <input type="checkbox" name="terms" v-model="terms"/>
                          <div class="checkbox"></div>
                          <span class="title">{{$t('I agree with')}} </span>
                          <a @click="$parent.goToPage('privacy')" class="title">{{$t('privacy policy')}}</a>
                          <span class="title">{{$t('and')}} </span>
                          <a @click="$parent.goToPage('terms')" class="title">{{$t('terms and conditions')}}</a>
                        </div>
                      </label>
                    </div>
                    <div class="cta-container">
                      <button :class="['button blue', {'disabled': !requiredRegisterFieldsAreFilled}]" @click="submitRegister">
                        <span>{{$t('Sign Up')}}</span>
                      </button>
                    </div>
                    <transition name="slide">
                      <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="left-down">
            <div class="modal-bottom">
              <div class="desc">{{$t('Already have an account?')}}</div>
              <div class="link switch-register" @click="$parent.openSignInModal">{{$t('Log in with existing account')}}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="./../img/login.png" class="img"/>
        </div>
      </div>
    </div>
  </main>
</template>
  
  <script>
  
  export default {
    name: 'Register',
    props: [],
    components: {
    },
    data: function() {
      return {
        email: '',
        pass: '',
        name: '',
        surname: '',
        phone: '',
        passConfirm: '',
        terms: false
      }
    },
    mounted() {
      
    },
    computed: {
      requiredRegisterFieldsAreFilled() {
        let fieldsAreFilled;
        if(
          this.name && this.surname  && this.phone && 
          this.email && this.pass && this.passConfirm
          && this.terms 
        ) {
          fieldsAreFilled = true;
        } else {
          fieldsAreFilled = false;
        }
        return fieldsAreFilled;
      }
    },
    methods: {
      submitRegister() {
        let regData = {
          "name": this.name,
          "surname": this.surname,
          "email": this.email,
          "phone": this.phone,
          "password": this.pass,
          "passConfirm": this.passConfirm
        }
          this.$emit('registration', regData)
      }
    }
  }
  </script>